/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_NoneInputs */

const cs_property_legal_none = /** @type {(inputs: Property_Legal_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné právní PDF.`)
};

const en_property_legal_none = /** @type {(inputs: Property_Legal_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No legal PDF generated yet.`)
};

/**
* | output |
* | --- |
* | "No legal PDF generated yet." |
*
* @param {Property_Legal_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_none = /** @type {((inputs?: Property_Legal_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_none(inputs)
	return cs_property_legal_none(inputs)
});